<template>
    <div class="tutorial-area" @click.self="closeTutorial">
        <div class="tutorial-con">
          <div class="tutorial-top">
            <div class="mock-modal">
                <ScreenModalSetting class="dummy-modal" />
                </div>
            <div class="tutorial-guide">
                <div class="tutorial-tit">
                    <p class="guide-desc">{{ t('screen_tutorial_guide_desc') }}<br>
                        "<span v-html="t('screen_tutorial_guide_action')"></span>"
                    </p>
                    <div class="tt-ms-img">
                        <img src="/images/mouse-img.svg" alt="">
                    </div>
                </div>
            </div>
          </div>
          <div class="tt-btn-wrap">
            <button type="button" class="dca-btn">
                <img src="/images/tt-check.svg" alt="">
                <span>{{ t('screen_tutorial_dont_show') }}</span>
            </button>
            <button type="button" class="tt-close" @click="closeTutorial">{{ t('close') }}</button>
          </div>

          <div class="tt-logo-guide">
            <div class="tt-logo-wrap">
                <p class="tt-logo-txt" v-html="t('screen_tutorial_logo_desc')"></p>
                <img class="tt-arrow"  src="/images/tt-arrow.svg" alt="">
            </div>
            <img class="tt-scon-logo" src="/images/tt-scon-logo.svg" alt="">
          </div>
        </div>

    </div>

</template>

<script setup>
    import { useI18n } from 'vue-i18n';

    import ScreenModalSetting from '@/components/domains/chat/chat-screen/ScreenModalSetting.vue';

    const { t } = useI18n();

    const emit = defineEmits(['close']);

    const closeTutorial = () => {
        emit('close');
    };

</script>
<style scoped lang="scss">
    .tutorial-area{
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 999;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.6);

        .tutorial-con{
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            gap: 40px;
            padding-top: 5rem;
        }
        .tutorial-top{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 40px;
        }
    }

    .tutorial-tit{
        padding-bottom: 5rem;
    }
    .guide-desc{
        font-size: 28px;
        color: #fff;
        font-weight: 500;
    }
    .guide-desc>span{
        color: #A1B0FF;
    }
    .tt-ms-img{
        padding: 2rem 5rem 0;
    }
    .mock-modal .modal-overlay[data-v-e832e89e]{
        position: relative;
        pointer-events: none;
    }

    .tt-btn-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 804px;
        margin: 0 auto;
        .dca-btn{
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 0;

            span{
                color: #fff;
                font-size: 16px;
            }
        }
        .tt-close{
            color: #fff;
            border: 1px solid #fff;
            border-radius: 8px;
            font-size: 1rem;
        }
    }

    .tt-logo-guide{
        position: absolute;
        right: 0;
        bottom: 0;
        .tt-logo-wrap{
            display: flex;
            padding-right: 2.5rem;
            padding-bottom: 2.5rem;
            padding-left: 1rem;
            .tt-logo-txt{
                color: #fff;
                font-size: 1rem;
                :deep(span){
                    color: #A1B0FF;
                }
            }
        }
        .tt-scon-logo{
            position: absolute;
            right: 0.5rem;
            bottom: 0.5rem;
        }
    }

    @media(max-width:768px){
        .guide-desc{
            font-size: 1.5rem;
            text-align: center;
        }
        .tutorial-area .tutorial-top{
            flex-direction: column;
            gap: 1rem;
        }
        .tt-ms-img{
            display: none;
        }
        .tutorial-tit{
            padding-bottom: 1rem;
        }
        .tutorial-area .tutorial-con{
            padding: 2rem 1rem 0;
            gap: 0;
        }
    }
     @media(max-width:480px){
        .guide-desc{
            font-size: 1.25rem;
        }
        .tt-logo-guide{
            width: 100%;
        }
        .tt-logo-guide .tt-logo-wrap{
            padding-right: 0;
            align-items: flex-end;
        }
        .tt-arrow{
            position: absolute;
            right: 2rem;
        }
     }
</style>
